module.exports = __webpack_public_path__ + "img/generic.49463b05.svg";